/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One entry in the slim rail under the hero — a mode, a beta window, a season.
 * @export
 * @interface DropMode
 */
export interface DropMode {
    /**
     * 
     * @type {string}
     * @memberof DropMode
     */
    kicker: string;
    /**
     * 
     * @type {string}
     * @memberof DropMode
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropMode
     */
    meta?: string;
    /**
     * 
     * @type {string}
     * @memberof DropMode
     */
    href?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropMode
     */
    upcoming?: boolean;
}

/**
 * Check if a given object implements the DropMode interface.
 */
export function instanceOfDropMode(value: object): value is DropMode {
    if (!('kicker' in value) || value['kicker'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function DropModeFromJSON(json: any): DropMode {
    return DropModeFromJSONTyped(json, false);
}

export function DropModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropMode {
    if (json == null) {
        return json;
    }
    return {
        
        'kicker': json['kicker'],
        'title': json['title'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'href': json['href'] == null ? undefined : json['href'],
        'upcoming': json['upcoming'] == null ? undefined : json['upcoming'],
    };
}

export function DropModeToJSON(json: any): DropMode {
    return DropModeToJSONTyped(json, false);
}

export function DropModeToJSONTyped(value?: DropMode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kicker': value['kicker'],
        'title': value['title'],
        'meta': value['meta'],
        'href': value['href'],
        'upcoming': value['upcoming'],
    };
}

